<script>
  import { M } from '../../external';
  import { ignore } from '../../Common/tools';
  import { onMount } from 'svelte';
  import ProductReviewService from './service';
  import DropdownInputWithSearchAndAdd from '../Common/DropdownInputWithSearchAndAdd.svelte';
  import ColorPicker from '../../Common/ColorPicker.svelte';

  export let widget,
    onChange = ignore,
    refreshUI = ignore;

  let widgetData = widget.data;

  const existingContexts = {
    isLoading: false,
    data: []
  };

  const numberOptions = [3, 5, 10, 20];

  const roleOptions = [
    { value: 0, name: M.ONLY_ADMINS },
    { value: 1, name: M.ADMINS_MODERATORS },
    { value: 2, name: M.ALL_MEMBERS }
  ];

  let selectedContext = {
    resourceId: '',
    name: '',
    moderation: { writePermission: 0, approvalRequired: 0 },
    commentModeration: { writePermission: 0, approvalRequired: 0 },
    extra: {
      allowMentions: false,
      allowImages: false,
      notifyOnReply: 'ONLY_FIRST_DEPTH'
    }
  };

  const onChangeAndRefresh = () => {
    onChange();
    refreshUI();
  };

  const onContextChanged = (selected) => {
    widgetData.resourceId = selected.resourceId;
    selectedContext = selected;
    onChangeAndRefresh();
    checkIfContextIsOutdated();
  };

  const onContextUpdated = (partialUpdate) => {
    ProductReviewService.partialUpdateContext(selectedContext.resourceType, selectedContext.resourceId, partialUpdate);
  };

  const checkIfContextIsOutdated = () => {
    if (!selectedContext.extra.notifyOnReply) {
      if (confirm('Context out-of-date. \'notifyOnReply\' is not set. Do you want me to upgrade?')) {
        onContextUpdated({ extra: { notifyOnReply: 'ONLY_FIRST_DEPTH' } });
        selectedContext.extra.notifyOnReply = 'ONLY_FIRST_DEPTH';
      }
    }
  };

  onMount(async () => {
    existingContexts.isLoading = true;
    existingContexts.data = await ProductReviewService.getContexts();
    selectedContext = existingContexts.data.find((context) => context.resourceId === widgetData.resourceId) || {
      resourceId: '',
      name: '',
      moderation: { writePermission: 0, approvalRequired: 0 },
      commentModeration: { writePermission: 0, approvalRequired: 0 },
      extra: {
        allowMentions: false,
        allowImages: false,
        notifyOnReply: 'ONLY_FIRST_DEPTH'
      }
    };
    existingContexts.isLoading = false;

    checkIfContextIsOutdated();
  });
</script>

<div class="popup-widget-wrapper">
  <div class="input-wrapper">
    <div class="info" style="width: 100%; margin-top: 5px">
      <h5>{M.ENTER_NAME}</h5>
    </div>
    {#if !existingContexts.isLoading}
      <div class="col20 f-left">
        <DropdownInputWithSearchAndAdd
          service={ProductReviewService}
          inputValue={selectedContext.name}
          onChange={onContextChanged}
          options={existingContexts.data} />
      </div>
    {/if}
  </div>
  <!--<div class="popup-input-wrapper mb-0">
    <div class="info">
      <h5>{M.REVIEW_STYLE}</h5>
      <span>{M.REVIEW_STYLE_DESC}</span>
      <select
        class="button-size-select"
        name="order"
        bind:value={widgetData.headerStyle}
        on:change={onChangeAndRefresh}
        style="width: 100%">
        <option value="alpha">Alpha</option>
        <option value="beta">Beta</option>
      </select>
    </div>
  </div>-->
  <div class="popup-input-wrapper mb-10">
    <div class="checkbox-wrapper">
      <input
        id="isModerationEnabled"
        checked={selectedContext?.moderation?.approvalRequired < 2}
        on:change={(event) => {
          event.target.checked
            ? onContextUpdated({ moderation: { approvalRequired: 1 } })
            : onContextUpdated({ moderation: { approvalRequired: 2 } });
        }}
        class="css-checkbox"
        type="checkbox"
        name="isModerationEnabled" />
      <label for="isModerationEnabled" class="css-label button-tooltip" data-original-title="" title=""
      >{M.REVIEW_REQUIRE_APPROVAL}</label>
    </div>
  </div>
  <div class="popup-input-wrapper mb-10">
    <div class="info">
      <h5>{M.SOCIAL_WHO_CAN_REPLY}</h5>
    </div>
    <select
      class="col20 f-left"
      bind:value={selectedContext.commentModeration.writePermission}
      on:change={() => {
        onContextUpdated({ commentModeration: { writePermission: selectedContext.commentModeration.writePermission } });
      }}>
      {#each roleOptions as option}
        <option value={option.value}>{option.name}</option>
      {/each}
    </select>
  </div>
  <div class="popup-input-wrapper mb-0">
    <div class="checkbox-wrapper">
      <input
        id="commentIsModerationEnabled"
        checked={selectedContext?.commentModeration?.approvalRequired < 2}
        on:change={(event) => {
          event.target.checked
            ? onContextUpdated({ commentModeration: { approvalRequired: 1 } })
            : onContextUpdated({ commentModeration: { approvalRequired: 2 } });
        }}
        class="css-checkbox"
        type="checkbox"
        name="commentIsModerationEnabled" />
      <label for="commentIsModerationEnabled" class="css-label button-tooltip" data-original-title="" title=""
      >{M.SOCIAL_REQUIRE_REPLY_APPROVAL}</label>
    </div>
  </div>
  <div class="popup-input-wrapper mt-5 mb-0">
    <div class="checkbox-wrapper">
      <input
        id="allowImages"
        bind:checked={selectedContext.extra.allowImages}
        on:change={() => {
          onContextUpdated({ extra: { allowImages: selectedContext.extra.allowImages } });
        }}
        class="css-checkbox"
        type="checkbox"
        name="allowImages" />
      <label for="allowImages" class="css-label button-tooltip" data-original-title="" title="">{M.ALLOW_IMAGES}</label>
    </div>
  </div>
  <!--  <div class="popup-input-wrapper mb-0">-->
  <!--    <div class="checkbox-wrapper">-->
  <!--      <input-->
  <!--        id="allowMentions"-->
  <!--        bind:checked={selectedContext.allowMentions}-->
  <!--        on:change={() => {-->
  <!--          onContextUpdated({ allowMentions: selectedContext.allowMentions });-->
  <!--        }}-->
  <!--        class="css-checkbox"-->
  <!--        type="checkbox"-->
  <!--        name="allowMentions" />-->
  <!--      <label for="allowMentions" class="css-label button-tooltip" data-original-title="" title="">Allow Mentions</label>-->
  <!--    </div>-->
  <!--  </div>-->
  <div class="popup-input-wrapper mt-10 mb-0">
    <div class="info">
      <h5>{M.ORDER_FILTER}</h5>
      <span>{M.ORDER_DESC}</span>
      <select
        class="button-size-select"
        name="order"
        bind:value={widgetData.order}
        on:change={onChangeAndRefresh}
        style="width: 100%">
        <option value="asc">{M.ASCENDING}</option>
        <option value="desc">{M.DESCENDING}</option>
      </select>
    </div>
  </div>
  <div class="popup-input-wrapper mt-10 mb-0">
    <div class="info">
      <h5>{M.REVIEW_INITIAL_NUMBER_OF_REVIEWS_TO_DISPLAY}</h5>
    </div>
    <select class="col20 f-left" bind:value={widgetData.initialCommentCount} on:change={onChangeAndRefresh}>
      {#each numberOptions as option}
        <option value={option}>{option}</option>
      {/each}
    </select>
  </div>
  <div class="popup-input-wrapper mt-10 mb-0">
    <div class="checkbox-wrapper">
      <input
        id="isDarkTheme"
        bind:checked={widgetData.isDarkTheme}
        on:change={() => {
          onChange();
          refreshUI();
        }}
        class="css-checkbox"
        type="checkbox"
        name="isDarkTheme" />
      <label for="isDarkTheme" class="css-label button-tooltip">
        {M.USE_LIGHT_UI}
      </label>
    </div>
  </div>
  <div class="col20 f-left">
    <div class="input-wrapper col20 f-left color-pick-wrap-widgets">
      <ColorPicker
        bind:color={widgetData.bgColor}
        bind:colorClass={widgetData.bgColorClass}
        label={M.BG_COLOR}
        onChange={onChangeAndRefresh} />
    </div>
  </div>
</div>
